import { useState, useEffect, useRef } from 'react'
import { useTranslation } from "react-i18next";
import '../translate';
import '../translate/translate';
import '../styles/ProfileModal.css';
import { useAuth } from "../providers/AuthProvider.jsx";
import { t } from 'i18next';


function Withdraw({ setIsWithdrawOpen }) {
    const { user } = useAuth()

    
    const [uzsBalance, setUzsBalance] = useState(0.00)
    const [usdBalance, setUsdBalance] = useState(0.00)
    const [rubBalance, setRubBalance] = useState(0.00)
    const [currencyState, setCurrencyState] = useState('usd')
    const [isWithdrawalOpen, setIsWithdrawalOpen] = useState(false)
    const [userId, setUserId] = useState(null)
    const [method, setMethod] = useState(null)
    const [minValue, setMinValue] = useState(null)
    useEffect(() => {
        if(user) {
            setUzsBalance(user.uzsBalance)
            setUsdBalance(user.usdBalance)
            setRubBalance(user.rubBalance)
            setCurrencyState(user.mainWallet)
            setUserId(user.id)

        }
    }, [user])

    useEffect(() => {
        if(currencyState === 'uzs') {
            setMinValue('325 000.00')
        } else if (currencyState === 'usd') {
            setMinValue('30.00')
        } else if (currencyState === 'rub') {
            setMinValue('3 000.00')
        }
    }, [currencyState])


    const formatNumber = (number) => {
        return new Intl.NumberFormat('ru-RU', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(number);
      };


      function Withdrawal({ userId, method }) {
        const [isLoading, setIsLoading] = useState(false)
        const [value, setValue] = useState("");

        const [responseModal, setResponseModal] = useState(false)
        const [responseText, setResponseText] = useState("")
        const [responseState, setResponseState] = useState(null);
        const [userBalance, setUserBalance] = useState(0)

        useEffect(() => {
            setValue(minValue)
        },[minValue])

        function ResponseModal({setIsWithdrawOpen, responseText, responseState }) {

            return (
                <div className={'response-modal-wrapper'}>
                    <img width={40} src={responseState ? "/assets/img/main/success-icon.svg" : "/assets/img/main/error-icon.svg"} alt="" />
                    <p className={'response-modal-title'}>{responseState ? "Success" : "Error"}</p>
                    <p dangerouslySetInnerHTML={{ __html: responseText }}></p>
                    <div className={`response-modal-button ${responseState ? "green" : "red"}`} onClick={() => {
                        if(responseState) {
                            setIsWithdrawOpen(false)
                        }
                        setIsLoading(false)
                        setResponseModal(false)
                    }}>OK</div>
                </div>
            )
        }

        const formatNumber = (num) => {
            if (!num) return "";
            const parts = num.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(".");
          };
        
          const handleChange = (e) => {
            let inputValue = e.target.value;
            // Удаляем все символы, кроме цифр и точки
            inputValue = inputValue.replace(/[^0-9.]/g, "");
            // Убираем лишние точки
            const parts = inputValue.split(".");
            if (parts.length > 2) {
              inputValue = parts[0] + "." + parts[1];
            }
            // Обновляем состояние с форматированием
            setValue(formatNumber(inputValue));
          };

          const formatButtons = (number) => {
            const formatted = new Intl.NumberFormat('ru-RU', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(number);
              return formatted.replace(',', '.'); // Заменяет запятую на точку
          };


          const formatInputToNumber = (inputValue) => {
            const cleanedValue = inputValue.replace(/\s/g, ''); // Удалить все пробелы
            const numberValue = parseFloat(cleanedValue); // Преобразовать строку в число
            return numberValue;
        };

            useEffect(() => {
                if(user) {
                    setUserBalance(user[`${user.mainWallet}Balance`])
                }
            }, [user])


          const withdrawFetch = async (method, wallet, amount) => {
            setIsLoading(true)
            const token = localStorage.getItem('token');


    
            try {
                const response = await fetch(`${import.meta.env.VITE_API_URL}/withdraw`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ method, wallet, amount, type: 'withdraw'}),
                })
    
    
                if (response.ok) {
                    const data = await response.json();
                    console.log(data.detail)
                    setIsLoading(false)
                    setResponseState(true)
                    setResponseText(`${t("mp_your_withdrawal_request")}`)
                    setResponseModal(true)
                  } else {
                    const errorData = await response.json();
                    setResponseState(false)
                    setResponseText(`${t("mp_an_error_occurred")}`)
                    setResponseModal(true)
                    
                  }
            } catch (error) {
                setResponseState(false)
                setResponseText(`${t("mp_an_error_occurred")}`)
                setResponseModal(true)
            }
          
    }


            const [cardNumber, setCardNumber] = useState('');
            const [cardExpire, setCardExpire] = useState('');

        return (
            <div className={'profile-modal-wrapper'}>
            <div className={'profile-modal-container'}>
                <img className={'profile-modal-close-button'} src="/assets/img/main/close_button.svg" alt="" onClick={() => setIsWithdrawOpen(false)}/>
                <div className={'profile-modal-title'}>
                    <span>{`ID #${120000 + userId }`}</span>
                </div>
                <div className={'transfer-method-change-wrap'}>
                    <div className={'transfer-method-left-wrap'}>
                        {method === 'uzcard' && <img width={35} src="/assets/img/main/uzcardlogo.svg" alt="" />}
                        {method === 'humo' && <img style={{"margin": "0 5px"}} width={40} src="/assets/img/main/humologo1.png" alt="" />}
                        {method === 'payme' && <img style={{"margin": "0 5px"}} width={40} src="/assets/img/main/payme-logo.svg" alt="" />}
                        {method === 'click' && <img style={{"margin": "0 5px"}} width={40} src="/assets/img/main/logo_click.svg" alt="" />}
                        <div className={'transfer-method-left-wrap-item'}>
                            {currencyState === 'uzs' && <p>Bank card</p>}
                            {currencyState === 'rub' && <p>Bank card</p>}
                            {currencyState === 'usd' && <p>Crypto Currency</p> }
                            <span>{t("mp_withdrawal_to")} {method.toUpperCase()}</span>
                        </div>
                    </div>
                    <div className={'transfer-method-change-button'} onClick={() => {
                        setIsWithdrawalOpen(false)
                    }}>{t("mp_change")}</div>
                </div>
                {currencyState === 'uzs' && <div className={'withdrawal-limit-text'}>{t("mp_limit_of_one_withdrawal")}: UZS 325,000 - UZS 15,000,000</div>}
                {currencyState === 'usd' && <div className={'withdrawal-limit-text'}>{t("mp_limit_of_one_withdrawal")}: USD 30.00 - USD 10 000.00</div>}
                {currencyState === 'rub' && <div className={'withdrawal-limit-text'}>{t("mp_limit_of_one_withdrawal")}: RUB 3 000 - RUB 150 000.00</div>}
                <div className={'transfer-amount-wrapper'}>
                    {(currencyState === 'rub' || currencyState === 'uzs') && <div>
                    <div className={'transfer-amount-title'}>
                        <p style={{"font-size": "10px"}}>Card format 8600123412341234</p>
                        
                    </div>
                    <div className={'withdrawal-card-input'}>
                            <input
                                type="text"
                                placeholder="Card number"
                                maxLength={16} // Ограничение на 16 символов
                                value={cardNumber} // Значение из стейта
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, ''); // Удалить все нечисловые символы
                                    setCardNumber(value); // Сохранить в стейт
                                }}
                            />
                    </div>
                    <div className={'withdrawal-card-input mt'}>
                <input
                    type="text"
                    placeholder="Card expire date DD/YY"
                    maxLength={5} // Ограничение на 5 символов
                    value={cardExpire} // Значение из стейта
                    onChange={(e) => {
                        let value = e.target.value.replace(/\D/g, ''); // Удалить все символы, кроме цифр
                        if (value.length > 2) {
                            value = value.slice(0, 2) + '/' + value.slice(2); // Добавить '/' после двух символов
                        }
                        setCardExpire(value); // Сохранить в стейт
                    }}
                />
                    </div>
                    </div>}
                        
                    {currencyState === 'usd' && <div>
                        <div className={'withdrawal-card-input'} style={{"margin-bottom": "15px"}}>
                            <input
                                style={{"width": "100%"}}
                                type="text"
                                placeholder="USDT TRC20 Wallet"
                                maxLength={40} // Ограничение на 16 символов
                                value={cardNumber} // Значение из стейта
                                onChange={(e) => {
                                    const value = e.target.value // Удалить все нечисловые символы
                                    setCardNumber(value); // Сохранить в стейт
                                }}
                            />
                    </div>
                    </div>}
                    <div className={'transfer-amount-input-wrap'}>
                        <div className={'transfer-amount-currency'}>
                            {currencyState ? currencyState.toUpperCase() : ""}
                            <p className={'transfer-amount-currency-wall'}></p>
                        </div>
                        <div style={{"width": "100%", "height": "100%", "padding-right": "10px", "display": "flex", "align-items": "center"}}>
                            <input 
                            className={'transfer-amount-input'} 
                            type="decimal" 
                            placeholder='325 000.00'
                            value={value}
                            onChange={handleChange}
                            />
                        </div>
                    </div>
                </div>
                <div className={'transfer-continue-button'} onClick={() => {
                    if(currencyState === 'uzs' && cardNumber.length < 16) {
                        setResponseModal(true)
                        setResponseState(false)
                        setResponseText(`${t("mp_incorrect_card_number")}`)
                        
                    } else if (currencyState === 'rub' && cardNumber.length < 16) {
                        setResponseModal(true)
                        setResponseState(false)
                        setResponseText(`${t("mp_incorrect_card_number")}`)
                    } else if (currencyState === 'usd' && cardNumber.length < 16) {
                        setResponseModal(true)
                        setResponseState(false)
                        setResponseText(`${t("mp_incorrect_wallet")}`)
                    }
                    else if (formatInputToNumber(value) > formatInputToNumber(userBalance)) {
                        setResponseModal(true)
                        setResponseState(false)
                        setResponseText(`${t("mp_not_enough")}`)
                    } else if (parseFloat(minValue.replace(/\s/g, '')) > parseFloat(value.replace(/\s/g, ''))) {
                        setResponseModal(true)
                        setResponseState(false)
                        setResponseText(`${t("mp_minimum_withdrawal_amount")}: <br /> ${minValue} ${currencyState.toUpperCase()}`)
                    } else {
                        withdrawFetch(method, currencyState, value)
                    }
                }}>
                    {t("mp_withdraw_funds")}
                </div>
                {isLoading && <div className={'modal-loader-wrapper'}>
                        <img src="/assets/img/main/loading.svg" alt="" />
                    </div>}
                
            </div>
            {responseModal && <div className={'profile-modal-wrapper'}><ResponseModal setIsWithdrawOpen={setIsWithdrawalOpen} responseText={responseText} responseState={responseState} /></div>}
            </div>
        )
      }


    return (
        <div className={'profile-modal-wrapper'}>
            <div className={'profile-modal-container'}>
                <img className={'profile-modal-close-button'} src="/assets/img/main/close_button.svg" alt="" onClick={() => setIsWithdrawOpen(false)}/>
                <div className={'profile-modal-title'}>
                    <span>{t("mp_withdraw")}</span>
                </div>
                <div className={'deposit-currency-wrapper'}>
                    <div className={'deposit-currency-wrap-title'}>
                        {t("mp_select_wallet_to_withdrawal")}
                    </div>
                    <div className={'deposit-selector-container'}>
                        <p className={'deposit-selector-currency'}>
                            {currencyState.toUpperCase()}
                        </p>
                        <p className={'deposit-selector-currency-wall'}></p>
                        <p className={'deposit-selector-amount'}>{formatNumber({ uzs: uzsBalance, usd: usdBalance, rub: rubBalance }[currencyState] || 0)} ({currencyState.toUpperCase()})</p>
                        
                    </div>
                    <div className={'deposit-methods-container'}>
                        <div className={'deposit-methods-container-title'}>
                            {t("mp_all_methods")}
                        </div>
                        <div className={'deposit-methods-available'}>{t("mp_available_methods")}</div>
                        {currencyState === 'uzs' && <div className={'deposit-methods-container-wrap'}>
                            <div className={'deposit-method-wrapper'} onClick={() => {
                                setMethod('uzcard')
                                setIsWithdrawalOpen(true)
                            }}>
                                <div><img className={'deposit-method-wrapper-uzcard-logo'} src="/assets/img/main/uzcardlogo.svg" alt="" /></div>
                                <div>Withdrawal to UZCARD</div>
                            </div>
                            <div className={'deposit-method-wrapper'} onClick={() => {
                                setMethod('humo')
                                setIsWithdrawalOpen(true)
                            }}>
                                <div><img className={'deposit-method-wrapper-humo-logo'} src="/assets/img/main/humologo1.png" alt="" /></div>
                                <div>Withdrawal to HUMO</div>
                            </div>
                        </div>}
                        {currencyState === 'usd' && <div className={'deposit-methods-container-wrap'}>
                            <div className={'deposit-method-wrapper'} onClick={() => {
                                setMethod('usdt')
                                setIsWithdrawalOpen(true)
                            }}>
                                <div><img className={'deposit-method-wrapper-uzcard-logo'} src="/assets/img/main/tron-logo.svg" alt="" /></div>
                                <div>Withdrawal to USDT TRC20</div>
                            </div>
                            
                        </div>}
                        {currencyState === 'rub' && <div className={'deposit-methods-container-wrap'}>
                            <div className={'deposit-method-wrapper'} onClick={() => {
                                setMethod('mir')
                                setIsWithdrawalOpen(true)
                            }}>
                                <div><img className={'deposit-method-wrapper-uzcard-logo'} src="/assets/img/main/mir-logo.svg" alt="" /></div>
                                <div>Withdrawal to MIR</div>
                            </div>
                            
                        </div>}
                    </div>
                </div>
            </div>
            {isWithdrawalOpen && <Withdrawal userId={userId} method={method} />}
        </div>
        
    )
}

export default Withdraw;